import React from 'react';
import { PersonalLayout } from '../components/PersonalLayout';
import { useEntityStore, PERSONAL_VIEW_OPTIONS } from '../store';

// v1 placeholder: no API calls, no financial data. Keeping this page
// inert means there is nothing to 404 or 500.

export function PersonalSpendingsPage() {
  const personalView = useEntityStore((s) => s.personalView);

  return (
    <PersonalLayout>
      <div className="space-y-6">
        <h1 className="text-3xl font-bold tracking-tight">
          Spendings <span className="text-muted-foreground font-normal text-lg">({PERSONAL_VIEW_OPTIONS.find((v) => v.key === personalView)?.shortLabel})</span>
        </h1>
        <p className="text-muted-foreground mt-1">Not yet wired</p>
      </div>
    </PersonalLayout>
  );
}
